/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ClientBillingAggregationResult } from '../models/client-billing-aggregation-result';
import { ClientMonthYearDTO } from '../models/client-month-year-dto';
import { OkResult } from '../models/ok-result';
import { AcceptedResponseBody } from '../models/accepted-response-body';
@Injectable({
  providedIn: 'root',
})
class AggregationResultService extends __BaseService {
  static readonly GetPrevMonthPath = '/aggregationresult/PrevMonth';
  static readonly GetClientsReadyForTransmitPath = '/aggregationresult/transmit';
  static readonly CompletePath = '/aggregationresult/complete/{id}';
  static readonly RerunPath = '/aggregationresult/rerun';
  static readonly RerunAggregationResultPath = '/aggregationresult/reaggregate';
  static readonly DeleteAggregationProcessPath = '/aggregationresult/DeleteAggregationProcess';
  static readonly UpdatePath = '/aggregationresult';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetPrevMonthResponse(Authorization?: string): __Observable<__StrictHttpResponse<Array<ClientBillingAggregationResult>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/aggregationresult/PrevMonth`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ClientBillingAggregationResult>>;
      })
    );
  }
  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetPrevMonth(Authorization?: string): __Observable<Array<ClientBillingAggregationResult>> {
    return this.GetPrevMonthResponse(Authorization).pipe(
      __map(_r => _r.body as Array<ClientBillingAggregationResult>)
    );
  }

  /**
   * @param Authorization Bearer token
   */
  GetClientsReadyForTransmitResponse(Authorization?: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/aggregationresult/transmit`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param Authorization Bearer token
   */
  GetClientsReadyForTransmit(Authorization?: string): __Observable<null> {
    return this.GetClientsReadyForTransmitResponse(Authorization).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `AggregationResultService.CompleteParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `Authorization`: Bearer token
   */
  CompleteResponse(params: AggregationResultService.CompleteParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/aggregationresult/complete/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `AggregationResultService.CompleteParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `Authorization`: Bearer token
   */
  Complete(params: AggregationResultService.CompleteParams): __Observable<null> {
    return this.CompleteResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `AggregationResultService.RerunParams` containing the following parameters:
   *
   * - `clientMonthYearDTO`:
   *
   * - `Authorization`: Bearer token
   */
  RerunResponse(params: AggregationResultService.RerunParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.clientMonthYearDTO;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/aggregationresult/rerun`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `AggregationResultService.RerunParams` containing the following parameters:
   *
   * - `clientMonthYearDTO`:
   *
   * - `Authorization`: Bearer token
   */
  Rerun(params: AggregationResultService.RerunParams): __Observable<null> {
    return this.RerunResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `AggregationResultService.RerunAggregationResultParams` containing the following parameters:
   *
   * - `clientMonthYearDTO`:
   *
   * - `Authorization`: Bearer token
   */
  RerunAggregationResultResponse(params: AggregationResultService.RerunAggregationResultParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.clientMonthYearDTO;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/aggregationresult/reaggregate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `AggregationResultService.RerunAggregationResultParams` containing the following parameters:
   *
   * - `clientMonthYearDTO`:
   *
   * - `Authorization`: Bearer token
   */
  RerunAggregationResult(params: AggregationResultService.RerunAggregationResultParams): __Observable<null> {
    return this.RerunAggregationResultResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `AggregationResultService.DeleteAggregationProcessParams` containing the following parameters:
   *
   * - `cbAggregationResults`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  DeleteAggregationProcessResponse(params: AggregationResultService.DeleteAggregationProcessParams): __Observable<__StrictHttpResponse<OkResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.cbAggregationResults;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/aggregationresult/DeleteAggregationProcess`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OkResult>;
      })
    );
  }
  /**
   * @param params The `AggregationResultService.DeleteAggregationProcessParams` containing the following parameters:
   *
   * - `cbAggregationResults`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  DeleteAggregationProcess(params: AggregationResultService.DeleteAggregationProcessParams): __Observable<OkResult> {
    return this.DeleteAggregationProcessResponse(params).pipe(
      __map(_r => _r.body as OkResult)
    );
  }

  /**
   * @param params The `AggregationResultService.UpdateParams` containing the following parameters:
   *
   * - `updatedResult`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  UpdateResponse(params: AggregationResultService.UpdateParams): __Observable<__StrictHttpResponse<AcceptedResponseBody>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.updatedResult;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/aggregationresult`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AcceptedResponseBody>;
      })
    );
  }
  /**
   * @param params The `AggregationResultService.UpdateParams` containing the following parameters:
   *
   * - `updatedResult`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  Update(params: AggregationResultService.UpdateParams): __Observable<AcceptedResponseBody> {
    return this.UpdateResponse(params).pipe(
      __map(_r => _r.body as AcceptedResponseBody)
    );
  }
}

module AggregationResultService {

  /**
   * Parameters for Complete
   */
  export interface CompleteParams {
    id: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for Rerun
   */
  export interface RerunParams {
    clientMonthYearDTO?: ClientMonthYearDTO;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for RerunAggregationResult
   */
  export interface RerunAggregationResultParams {
    clientMonthYearDTO?: ClientMonthYearDTO;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for DeleteAggregationProcess
   */
  export interface DeleteAggregationProcessParams {
    cbAggregationResults?: Array<ClientBillingAggregationResult>;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for Update
   */
  export interface UpdateParams {
    updatedResult?: ClientBillingAggregationResult;

    /**
     * Bearer token
     */
    Authorization?: string;
  }
}

export { AggregationResultService }
